export const OOF_ITEM_CLASS_REGEX = /ipm.note.rules.ooftemplate.microsoft/i;
